module.exports = __webpack_public_path__ + "img/save.4eefe8c9.svg";